import axios from "axios";

const BASE_URL = "https://mhgap.api.kcstaging.in"


const api = {

login: async (userid, password, additionalData) => {
    try {
      const requestData = {
        userid,
        password,
        ...additionalData,
      };
      const response = await axios.post(`${BASE_URL}/mhgapreact/web_login`, requestData, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Login error:", error.message);
      throw error;
    }
},

get_States:  async (requestData) => {
    try {
      const response = await axios.post(`${BASE_URL}/mhgapreact/web_get_state`, requestData, {
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching raw data:", error.message);
      throw error;
    }
},

get_District:  async (requestData) => {
  try {
    const response = await axios.post(`${BASE_URL}/mhgapreact/web_get_district`, requestData, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching raw data:", error.message);
    throw error;
  }
},

get_Site:  async (requestData) => {
  try {
    const response = await axios.post(`${BASE_URL}/mhgapreact/web_get_site`, requestData, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching raw data:", error.message);
    throw error;
  }
},

get_Taluk:  async (requestData) => {
  try {
    const response = await axios.post(`${BASE_URL}/mhgapreact/web_get_taluk`, requestData, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching raw data:", error.message);
    throw error;
  }
},

get_Village:  async (requestData) => {
  try {
    const response = await axios.post(`${BASE_URL}/mhgapreact/web_get_village`, requestData, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching raw data:", error.message);
    throw error;
  }
},

add_PHC:  async (requestData) => {
  try {
    const response = await axios.post(`${BASE_URL}/mhgapreact/web_create_phc`, requestData, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching raw data:", error.message);
    throw error;
  }
},

get_Created_Geo:  async (requestData) => {
  try {
    const response = await axios.post(`${BASE_URL}/mhgapreact/web_get_all_phc`, requestData, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting users:", error.message);
    throw error;
  }
},

get_PHC:  async (requestData) => {
  try {
    const response = await axios.post(`${BASE_URL}/mhgapreact/web_get_phc`, requestData, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching raw data:", error.message);
    throw error;
  }
},

get_Reporting_PRS:  async (requestData) => {
  try {
    const response = await axios.post(`${BASE_URL}/mhgapreact/web_reporting_prs`, requestData, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching raw data:", error.message);
    throw error;
  }
},

get_Replaced_User:  async (requestData) => {
  try {
    const response = await axios.post(`${BASE_URL}/mhgapreact/web_get_inactive_user`, requestData, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching raw data:", error.message);
    throw error;
  }
},

add_User:  async (requestData) => {
  try {
    const response = await axios.post(`${BASE_URL}/mhgapreact/web_create_user`, requestData, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding user:", error.message);
    throw error;
  }
},

get_Created_Users:  async (requestData) => {
  try {
    const response = await axios.post(`${BASE_URL}/mhgapreact/web_data_tbl_user_master`, requestData, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting users:", error.message);
    throw error;
  }
},

get_User_Data:  async (requestData) => {
  try {
    const response = await axios.post(`${BASE_URL}/mhgapreact/web_get_logged_in_data`, requestData, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting users:", error.message);
    throw error;
  }
},

get_Raw_Data:  async (requestData) => {
  try {
    const response = await axios.post(`${BASE_URL}/mhgapreact/download_raw_reports`, requestData, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting users:", error.message);
    throw error;
  }
},

get_Filter_Site:  async (requestData) => {
  try {
    const response = await axios.post(`${BASE_URL}/mhgapreact/web_get_site_admin_users`, requestData, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting users:", error.message);
    throw error;
  }
},

get_Over_all_Dashboard:  async (requestData) => {
  try {
    const response = await axios.post(`${BASE_URL}/mhgapreact/site_admin_dashboard`, requestData, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting users:", error.message);
    throw error;
  }

  
},

get_PRS_Dashboard:  async (requestData) => {
  try {
    const response = await axios.post(`${BASE_URL}/mhgapreact/prs_site_admin_dashboard`, requestData, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting users:", error.message);
    throw error;
  }

  
},

get_HCW_Dashboard:  async (requestData) => {
  try {
    const response = await axios.post(`${BASE_URL}/mhgapreact/hcw_site_admin_dashboard`, requestData, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting users:", error.message);
    throw error;
  }
},



}

export default api;
